module.exports = __webpack_public_path__ + "img/6dab072.jpg";